import { IconCheck } from "@tabler/icons-react"
import { type FC, type FormEvent, useState } from "react"

import Button from "~/components/button"
import { Input } from "~/components/input"
import Layout from "~/components/layout"
import { useUser, useUserContext } from "~/context/user"
import { query } from "~/utilities/trpc"

const SettingsPage: FC = () => {
	const userContext = useUserContext()
	const user = useUser()!

	const [firstName, setFirstName] = useState(user.firstName)
	const [lastName, setLastName] = useState(user.lastName)
	const [bankgiro, setBankgiro] = useState(user.bankgiro ?? "")
	const [showSuccessMessage, setShowSuccessMessage] = useState(false)

	const updateProfileMutation = query.updateProfile.useMutation({
		onSuccess() {
			userContext.reload()
			setShowSuccessMessage(true)
			setTimeout(() => setShowSuccessMessage(false), 3000)
		},
		onError: error => console.error(error),
	})

	function handleSubmit(event: FormEvent) {
		event.preventDefault()
		if (firstName.trim().length === 0 || lastName.trim().length === 0) return

		updateProfileMutation.mutate({ firstName, lastName, bankgiro: bankgiro.trim() || null })
	}

	return (
		<Layout>
			<div className="mx-auto flex w-full max-w-6xl flex-col gap-8 py-10">
				<div>
					<h1 className="text-3xl font-semibold text-slate-900">Inställningar</h1>
					<p className="mt-2 text-slate-600">Ändra dina inställningar</p>
				</div>

				{showSuccessMessage && (
					<div className="flex max-w-2xl gap-3 rounded-md bg-green-50 p-4">
						<IconCheck className="size-5 shrink-0 text-green-400" />
						<p className="text-sm font-medium text-green-800">Dina inställningar har sparats!</p>
					</div>
				)}

				<form onSubmit={handleSubmit} className="max-w-2xl space-y-6">
					<div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
						<Input
							type="text"
							label="Förnamn"
							value={firstName}
							onChange={setFirstName}
							placeholder="Ange ditt förnamn"
							autoComplete="given-name"
							required
						/>
						<Input
							type="text"
							label="Efternamn"
							value={lastName}
							onChange={setLastName}
							placeholder="Ange ditt efternamn"
							autoComplete="family-name"
							required
						/>
					</div>

					<Input
						type="text"
						label="Bankgironummer"
						value={bankgiro}
						onChange={value => setBankgiro(value.replace(/[^\d-]/g, ""))}
						placeholder="Ange ditt Bankgironummer för utbetalningar"
					/>

					<div className="flex justify-end">
						<Button
							type="submit"
							color="green"
							disabled={updateProfileMutation.isPending || !firstName.trim() || !lastName.trim()}
						>
							{updateProfileMutation.isPending ? "Sparar..." : "Spara inställningar"}
						</Button>
					</div>
				</form>
			</div>
		</Layout>
	)
}

export default SettingsPage
